export function isAppWebView() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("app") === "1") return true;
  } catch {
    // ignore malformed URL state
  }

  try {
    if (window.localStorage.getItem("posm_app_webview") === "1") return true;
  } catch {
    // ignore storage access errors
  }

  const userAgent = String(window.navigator?.userAgent || "");
  return /POSMAppWebView/i.test(userAgent);
}
